/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/heading-has-content */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';

// import ProfileItem from "../components/top/ProfileItem";

//import { throttle, debounce } from 'throttle-debounce';
// import { Throttle, Debounce } from "react-throttle";
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
// import Event from "../containers/event/Event";

//import onClickOutside from "react-onclickoutside";

class TopMenu extends PureComponent {
  state = {
    topMenu: 'N',
    searchView: false,
    myShow: false,
    searchText: '',
    selectIndex: -1,
    showAutoKeyword: false,
    showEvent: false,
    showTimeline: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
  };
  _isMounted = false;
  _dupShowCount = 0;

  componentDidMount = () => {
    this._isMounted = true;
    window.addEventListener('scroll', this._listenToScroll);
    document.addEventListener('touchmove', this._listenToScroll);
    var body = document.querySelector('body');
    body.addEventListener('click', this.clickBodyEvent);
    this._getUserInfo();

    this._interval = setInterval(() => {
      this._getLoginCode();
    }, 1000 * 60);
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('scroll', this._listenToScroll);
    document.removeEventListener('touchmove', this._listenToScroll);
    var body = document.querySelector('body');
    body.removeEventListener('click', this.clickBodyEvent);

    clearInterval(this._interval);
  };
  clickBodyEvent = (event) => {
    var target = event.target;

    var eventTarget1 = event.currentTarget.querySelector('.btn_srch');
    var eventTarget2 = event.currentTarget.querySelector('.btn_mem');
    var eventTarget4 = event.currentTarget.querySelector('.btn_schedule');
    //var eventTarget3 = event.currentTarget.querySelector(".myArea")
    let eventTarget3;
    if (event.currentTarget.querySelector('.myArea')) {
      eventTarget3 = event.currentTarget
        .querySelector('.myArea')
        .querySelectorAll('img')[0];
    } else {
      eventTarget3 = '';
    }

    //console.log(target, eventTarget3)
    if (target === eventTarget1) {
      if (this._isMounted) {
        this.setState({
          //searchView: false,
          showEvent: false,
          myShow: false,
          //showTimeline: false
        });
      }
    } else if (target === eventTarget2) {
      if (this._isMounted) {
        this.setState({
          searchView: false,
          //showEvent: false,
          myShow: false,
          //showTimeline: false
        });
      }
    } else if (target === eventTarget4) {
      if (this._isMounted) {
        this.setState({
          searchView: false,
          showEvent: false,
          myShow: false,
        });
      }
    } else if (target === eventTarget3) {
      if (this._isMounted) {
        this.setState({
          searchView: false,
          showEvent: false,
          //showTimeline: false
          //myShow: false
        });
      }
    } else if (target === event.currentTarget.querySelector('.common_input')) {
    } else {
      setTimeout(() => {
        if (this._isMounted) {
          this.setState({
            //searchView: false,
            showEvent: false,
            myShow: false,
            //showTimeline: false
          });
        }
      }, 500);
    }

    /*
            if( target === event.currentTarget.querySelector(".common_input")) {

            } else {
                this.setState({
                    searchView: false,
                    showEvent: false,
                    myShow: false
                })
            }
        */
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  };

  _getLoginCode = async () => {
    // const { history } = this.props;
    const authCookies = this.getCookie('account');
    if (
      authCookies === '' ||
      authCookies === null ||
      authCookies === undefined
    ) {
    } else {
      const arrAuth = authCookies.split('&');

      if (arrAuth.length > 0) {
        arrAuth.sort();
        //console.log(arrAuth)
        //"loginCode=20201006034838_badgu_amds1hzu"
        const loginCode = arrAuth[4].substring(10, arrAuth[4].length);
        //console.log(loginCode)
        //this._getMemberInfo(authId);
        //this.getCartCount(authId);
        //console.log(this._dupShowCount)
        if (this._dupShowCount === 0) {
          const result = await this._getLoginCodeApi(loginCode);
          const intReturn = result.data[0].intReturn;

          //console.log('=====================>' + intReturn)

          if (intReturn === 0) {
          } else {
            this._dupShowCount = 1;

            confirmAlert({
              title: '동시접속 알림',
              message:
                '다른 기기에서 동시에 접속되어 현재 세션은 로그아웃 됩니다. 다른 기기의 접속상태를 확인 후 다시 이용해 주시기 바랍니다.',
              buttons: [
                {
                  label: '다시 로그인',
                  onClick: () => {
                    this._reLogin();
                  },
                },

                {
                  label: '확인',
                  onClick: () => {
                    this._onLogout();
                  },
                },
              ],
            });
          }
        }
      }
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }

    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _reLogin = () => {
    const { setLoginId, setAuthId, history } = this.props;

    this.setCookie('account', '');

    setLoginId('');
    setAuthId('');
    this._dupShowCount = 0;
    history.push('/login');
  };
  _onLogout = () => {
    const { setLoginId, setAuthId, history } = this.props;
    this.setState({
      showTimeline: false,
    });
    this.setCookie('account', '');
    this.setCookie('ad', '');
    this.setCookie('at', '');
    this.setCookie('rt', '');
    this.setCookie('ni', '');
    this.setCookie('ic', '');

    setLoginId('');
    setAuthId('');

    localStorage.removeItem('at');
    localStorage.removeItem('rt');

    toast.success('정상적으로 로그아웃 되었습니다.');

    history.push('/');
  };
  _getLoginCodeApi = (loginCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/dupCheck', {
        params: {
          userid: loginId,
          loginCode: loginCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _getUserInfo = async () => {
    const { loginId, setIcon } = this.props;

    if (loginId === '' || loginId === null || loginId === undefined) {
    } else {
      const result = await this._getUserInfoApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const userInfo = result.data[0].listData;
        //const eventCount = result.data[0].eventCount;
        if (intReturn === 0) {
          if (this._isMounted) {
            this.setState({
              userInfo,
            });
            //console.log(userInfo[0].icon)
            setIcon(userInfo[0].icon);
          }
        }
      }
    }
  };
  _getUserInfoApi = () => {
    const { apiUrl, loginId, pkg, history } = this.props;
    // const at = localStorage.getItem('at');
    //console.log(apiUrl + '/getUserInfo?userid=' + loginId)
    const at = this.getCookie('at');
    return axios(
      apiUrl + '/getUserInfo_pkg?userid=' + loginId + '&pkg=' + pkg,
      {
        headers: {
          Authorization: 'bearer ' + at,
        },
      }
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      // localStorage.setItem('at', data[0].at);
      this.setCookie('at', data[0].at);
      this._getUserInfo();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  _listenToScroll = (e) => {
    // console.log("...........");
    e.stopPropagation();

    const { topMenu } = this.state;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (topMenu === 'N') {
      if (winScroll > 70) {
        if (this._isMounted) {
          this.setState({
            topMenu: 'F',
          });
        }
      }
    } else if (topMenu === 'F') {
      if (winScroll < 50) {
        if (this._isMounted) {
          this.setState({
            topMenu: 'N',
          });
        }
      }
    }
  };

  _onToggleSearchView = () => {
    const { searchView } = this.state;
    console.log(searchView);

    if (this._isMounted) {
      this.setState({
        searchText: '',
        selectIndex: -1,
        keywordList: null,
        searchView: !searchView,
      });

      if (searchView === false) {
        setTimeout(() => {
          if (this.search) {
            this.search.focus();
          }
        }, 500);
      }
    }
  };
  _onToggleMyView = () => {
    const { myShow } = this.state;
    if (this._isMounted) {
      this.setState({
        myShow: !myShow,
      });
    }
  };
  _onScrollTop = () => {
    this.setState({
      showTimeline: false,
    });
    scroll.scrollToTop();
  };
  _onSearchChange = (e) => {
    //const { searchText } = this.state;
    //console.log(e.target.value)
    if (this._isMounted) {
      this.setState({
        searchText: e.target.value,
      });
      if (
        e.target.value === '' ||
        e.target.value === null ||
        e.target.value === undefined
      ) {
        this.setState({
          searchText: '',
          //searchView: false
        });
      } else {
        this._autoKeyword(e.target.value);
      }
    }
  };
  _autoKeyword = async (strFind) => {
    //console.log(strFind)
    const result = await this._autoKeywordApi(strFind);
    const intReturn = result.data[0].intReturn;
    const keywordList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          keywordList,
          showAutoKeyword: true,
        });
      }
    } else {
      if (this._isMounted) {
        this.setState({
          keywordList: null,
          showAutoKeyword: false,
        });
      }
    }
  };

  _autoKeywordApi = (strFind) => {
    const { apiUrl } = this.props;
    if (strFind === null || strFind === undefined || strFind === '') {
    } else {
      return axios(apiUrl + '/autoKeyword?strFind=' + strFind)
        .then((response) => response)
        .catch((error) => {
          //console.log('검색어 오류.')
        });
    }
  };
  _renderKeywordItem = () => {
    const { keywordList, selectIndex } = this.state;

    const list = keywordList.map((item, index) => {
      return (
        <p
          key={index}
          onClick={() => this._selectItem(item.title)}
          style={
            selectIndex === index ? { color: 'red', fontWeight: 900 } : null
          }
        >
          {item.title}
        </p>
      );
    });

    return list;
  };

  _selectItem = (title) => {
    if (this._isMounted) {
      this.setState({
        searchText: title,
        originText: title,
        showAutoKeyword: false,
      });

      this.search.focus();
    }
  };
  _goItem = (contentSreial) => {
    const { history } = this.props;
    this.setState({
      showTimeline: false,
    });
    window.scrollTo(0, 0);
    history.push('/items/' + contentSreial);
  };
  _onKeyup = (e) => {
    const { history } = this.props;
    const { originText, searchText, selectIndex, keywordList } = this.state;
    const key = e.keyCode;
    const keyLength = keywordList ? keywordList.length : 0;
    ////console.log(keywordList.length)
    ////console.log(selectIndex + 1)
    console.log(key);
    if (key === 13) {
      if (
        searchText === null ||
        searchText === undefined ||
        searchText === ''
      ) {
      } else {
        // console.log(originText);
        // console.log(searchText);
        let g = 'n';
        if (originText === searchText) {
          g = 'y';
        }

        history.push('/search?st=' + searchText + '&g=' + g);

        if (this._isMounted) {
          this.setState({
            searchText: '',
            originText: '',
            showAutoKeyword: false,
            selectIndex: -1,
          });
        }
      }
    } else if (key === 38) {
      //console.log(selectIndex);
      if (selectIndex > 0) {
        if (this._isMounted) {
          this.setState({
            selectIndex: selectIndex - 1,
            searchText: keywordList[selectIndex - 1].title,
            originText: keywordList[selectIndex - 1].title,
          });
        }
      }
    } else if (key === 40) {
      if (keyLength >= selectIndex + 2) {
        if (this._isMounted) {
          this.setState({
            selectIndex: selectIndex + 1,
            searchText: keywordList[selectIndex + 1].title,
            originText: keywordList[selectIndex + 1].title,
          });
        }
      }
    }
  };
  _goShop = () => {
    this.setState({
      showTimeline: false,
    });
    window.open('https://shop.aniplustv.com', '', '');
  };
  _goHome = () => {
    const { history } = this.props;
    //console.log(history)
    if (history.location.pathname === '/') {
      this.setState({
        showTimeline: false,
      });
      window.scrollTo(0, 0);
      window.location.reload(false);
    } else {
      this.setState({
        showTimeline: false,
      });
      window.scrollTo(0, 0);
      history.push('/');
    }
  };
  _goLogin = () => {
    const { history } = this.props;
    this.setState({
      showTimeline: false,
    });
    window.scrollTo(0, 0);
    history.push('/login');
  };
  _toggleEvent = () => {
    const { showEvent } = this.state;
    if (this._isMounted) {
      this.setState({
        showEvent: !showEvent,
      });
    }
  };
  _toggleTimeline = () => {
    const { showTimeline } = this.state;
    if (this._isMounted) {
      this.setState({
        showTimeline: !showTimeline,
      });
    }
  };
  onLiveTime = () => {
    const { setTvline, setTimeline } = this.props;
    this.setState({
      showTimeline: false,
    });

    setTvline(false);
    setTimeline(true);
  };
  onTvTime = () => {
    const { setTvline, setTimeline } = this.props;
    this.setState({
      showTimeline: false,
    });
    setTimeline(false);
    setTvline(true);
  };
  onWeekTime = () => {
    const { setTimelineWeek } = this.props;
    this.setState({
      showTimeline: false,
    });
    setTimelineWeek(true);
  };
  _tutorial = () => {
    const { setTutorialShow } = this.props;
    setTutorialShow(true);
  };
  _myPage = () => {
    const { history } = this.props;
    this.setState({
      showTimeline: false,
    });
    window.scrollTo(0, 0);
    history.push('/mypage/0');
  };
  _ticket = () => {
    const { history } = this.props;
    this.setState({
      showTimeline: false,
    });
    window.scrollTo(0, 0);
    history.push('/ticket');
  };
  _goLive = () => {
    const { history } = this.props;
    this.setState({
      showTimeline: false,
    });
    window.scrollTo(0, 0);
    history.push('/live');
  };
  _goVod = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);
    history.push('/list');
  };
  _goShop = () => {
    this.setState({
      showTimeline: false,
    });
    window.open('https://shop.aniplustv.com', '', '');
  };
  _goStore = () => {
    const { history } = this.props;
    this.setState({
      showTimeline: false,
    });
    window.scrollTo(0, 0);
    history.push('/store');
  };
  _menuEnter = (index) => {
    if (index === 0) {
      this.setState({
        menu1: true,
        menu2: false,
        menu3: false,
        menu4: false,
      });
    } else if (index === 1) {
      this.setState({
        menu1: false,
        menu2: true,
        menu3: false,
        menu4: false,
      });
    } else if (index === 2) {
      this.setState({
        menu1: false,
        menu2: false,
        menu3: true,
        menu4: false,
      });
    } else if (index === 3) {
      this.setState({
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: true,
      });
    }
  };
  _menuLeave = (index) => {
    //if(index === 0) {
    this.setState({
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
    });
  };
  render() {
    const {
      topMenu,
      searchView,
      searchText,
      keywordList,
      showAutoKeyword,
      showTimeline,
      menu1,
      menu2,
      menu3,
      menu4,
    } = this.state;
    const { loginId, history, nicName, serviceEndDate } = this.props;
    //console.log(showTimeline)
    return (
      <Fragment>
        {/* history.location.pathname === '/' ? ( 
                    <Tooltip title="새로워진 애니플러스!! 무엇이 달라졌을까?"> 
                    <div className="chatting_fixed" style={{cursor: 'pointer'}} onClick={this._tutorial}><span>채팅</span></div>
                    </Tooltip>
                ) : null */}

        <div className={topMenu === 'F' ? 'header header_fixed' : 'header'}>
          <h1
            className="logo"
            alt="로고"
            onClick={this._goHome}
            style={{ width: '10.1875rem' }}
          ></h1>
          <div className="nav">
            <ul className="lnb">
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
              serviceEndDate ? null : (
                <Tooltip title="국내 가장빠른 동시간대 LIVE 방송">
                  <li
                    onMouseEnter={() => this._menuEnter(0)}
                    onMouseLeave={() => this._menuLeave(0)}
                  >
                    <button
                      type="menu"
                      onClick={this._goLive}
                      className={
                        history.location.pathname.indexOf('/live') > -1
                          ? 'active'
                          : null
                      }
                    >
                      {menu1 ? '라이브' : 'LIVE'}
                    </button>
                  </li>
                </Tooltip>
              )}

              <Tooltip
                title={
                  moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                  serviceEndDate
                    ? '작품 정보'
                    : '1080P 고화질 다시보기/다운로드'
                }
              >
                <li
                  onMouseEnter={() => this._menuEnter(1)}
                  onMouseLeave={() => this._menuLeave(1)}
                >
                  <button
                    type="menu"
                    onClick={this._goVod}
                    className={
                      history.location.pathname.indexOf('/list') > -1
                        ? 'active'
                        : null
                    }
                  >
                    {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                    serviceEndDate
                      ? 'PROGRAM'
                      : menu2
                        ? '다시보기'
                        : 'VOD'}
                  </button>
                </li>
              </Tooltip>

              <Tooltip title="덕질의 완성은 굿즈!! 줍!줍!줍">
                <li
                  onMouseEnter={() => this._menuEnter(2)}
                  onMouseLeave={() => this._menuLeave(2)}
                >
                  <button type="menu" onClick={this._goShop}>
                    {menu3 ? '온라인 쇼핑몰' : 'GOODS'}
                  </button>
                </li>
              </Tooltip>

              <Tooltip title="서울, 대전, 광주, 부산 찍고!!!">
                <li
                  onMouseEnter={() => this._menuEnter(3)}
                  onMouseLeave={() => this._menuLeave(3)}
                >
                  <button
                    type="menu"
                    onClick={this._goStore}
                    className={
                      history.location.pathname.indexOf('/store') > -1 ||
                      history.location.pathname.indexOf('/store') > -1
                        ? 'active'
                        : null
                    }
                  >
                    {menu4 ? '직영점 소개' : 'STORE'}
                  </button>
                </li>
              </Tooltip>
            </ul>
          </div>
          <div className="gnb">
            <ul>
              <li>
                <Tooltip title="작품 검색">
                  <button
                    type="button"
                    className="btn_srch"
                    onClick={this._onToggleSearchView}
                  >
                    검색
                  </button>
                </Tooltip>
                {searchView ? (
                  <div className="top_search">
                    <div
                      className={
                        history.location.pathname.indexOf('/store') > -1 ||
                        history.location.pathname.indexOf('/story') > -1
                          ? 'top_search search_input'
                          : 'search_input input_on'
                      }
                    >
                      <input
                        ref={(ref) => (this.search = ref)}
                        type="text"
                        placeholder="[초성검색] 작품, 감독, 제작사명을 입력해 주세요"
                        className="common_input input_style1 "
                        value={searchText}
                        onChange={this._onSearchChange}
                        onKeyUp={this._onKeyup}
                      />
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={this._onToggleSearchView}
                      >
                        삭제
                      </span>
                    </div>
                    {showAutoKeyword ? (
                      keywordList ? (
                        <div className="search_text">
                          {keywordList ? this._renderKeywordItem() : null}
                        </div>
                      ) : null
                    ) : null}
                  </div>
                ) : null}
              </li>

              <li>
                <button
                  type="button"
                  className="gnb_link"
                  title="포인트 충전"
                  onClick={this._ticket}
                  style={{
                    color:
                      history.location.pathname.indexOf('/store') > -1 ||
                      history.location.pathname.indexOf('/story') > -1
                        ? null
                        : '#fff',
                  }}
                >
                  포인트
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="gnb_link"
                  title="편성표"
                  onClick={this._toggleTimeline}
                  style={{
                    color:
                      history.location.pathname.indexOf('/store') > -1 ||
                      history.location.pathname.indexOf('/story') > -1
                        ? null
                        : '#fff',
                  }}
                >
                  편성표
                </button>
                {showTimeline ? (
                  <div className="user_more2">
                    <dl>
                      <dd>
                        <span>
                          <a
                            onClick={this.onTvTime}
                            style={{
                              cursor: 'pointer',
                              color:
                                history.location.pathname.indexOf('/store') >
                                  -1 ||
                                history.location.pathname.indexOf('/story') > -1
                                  ? null
                                  : '#fff',
                            }}
                          >
                            TV 편성표
                          </a>
                        </span>
                        {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                        serviceEndDate ? null : (
                          <span>
                            <a
                              onClick={this.onLiveTime}
                              style={{
                                cursor: 'pointer',
                                color:
                                  history.location.pathname.indexOf('/store') >
                                    -1 ||
                                  history.location.pathname.indexOf('/story') >
                                    -1
                                    ? null
                                    : '#fff',
                              }}
                            >
                              LIVE 편성표
                            </a>
                          </span>
                        )}

                        <span>
                          <a
                            onClick={this.onWeekTime}
                            style={{
                              cursor: 'pointer',
                              color:
                                history.location.pathname.indexOf('/store') >
                                  -1 ||
                                history.location.pathname.indexOf('/story') > -1
                                  ? null
                                  : '#fff',
                            }}
                          >
                            신작 시간표
                          </a>
                        </span>
                      </dd>
                    </dl>
                  </div>
                ) : null}
              </li>

              {loginId === '' || loginId === undefined || loginId === null ? (
                <li>
                  <a
                    onClick={this._goLogin}
                    className="gnb_link user"
                    style={{
                      cursor: 'pointer',
                      color:
                        history.location.pathname.indexOf('/store') > -1 ||
                        history.location.pathname.indexOf('/story') > -1
                          ? null
                          : '#fff',
                    }}
                  >
                    로그인
                  </a>
                </li>
              ) : (
                <li>
                  <li>
                    <a
                      className="gnb_link user"
                      onClick={this._myPage}
                      style={{
                        cursor: 'pointer',
                        color:
                          history.location.pathname.indexOf('/store') > -1 ||
                          history.location.pathname.indexOf('/story') > -1
                            ? null
                            : '#fff',
                      }}
                    >
                      {nicName}님
                    </a>
                  </li>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(TopMenu)));
